import React from 'react';

const ShippingPolicy = () => {
  return (
    <div style={{ padding: '3rem 1.5rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'Inter, sans-serif', color: '#334155', lineHeight: '1.7' }}>
      <h1 style={{ color: '#0b2545', borderBottom: '1px solid #ddd', paddingBottom: '1rem' }}>Shipping & Delivery Policy</h1>
      
      <p>Abhikalp provides strategic consultancy services. As these are digital/professional services, no physical goods are shipped.</p>

      <h3>1. Mode of Delivery</h3>
      <ul>
        <li><strong>Consultations:</strong> Delivered via Video Conference (Zoom/Google Meet) or in-person meetings at the scheduled time. Meeting links are shared via email.</li>
        <li><strong>Documents & Reports:</strong> All drafts, risk maps, and advisory reports are delivered digitally <strong>via email</strong> to the address provided by the client.</li>
      </ul>

      <h3>2. Delivery Timelines</h3>
      <p>Timelines for document delivery (e.g., 3-5 business days) will be confirmed in your specific engagement email. Consultations are delivered instantly at the time of the appointment.</p>

      <p>For any delivery queries, contact <strong>support@abhikalpconsulting.com</strong>.</p>
    </div>
  );
};

export default ShippingPolicy;